import DynamedDecisionsHome from "./DynamedDecisionsHome";
export default DynamedDecisionsHome;
